const Layout = () => System.import('../../Shared/Layout/App/View/Layout');
const Cadastro = () => System.import('../App/View/Cadastro');

const Produto = () => System.import('../../Produto/App/View/Produto');
const ProdutoB2B = () => System.import('../../Produto/App/View/ProdutoB2B');
const DadosProduto = () => System.import('../../Produto/App/View/DadosProduto');

const Grupo = () => System.import('../../Produto/App/View/Grupo.vue');
const Subgrupo = () => System.import('../../Produto/App/View/Subgrupo.vue');
const Categoria = () => System.import('../../Produto/App/View/Categoria.vue');
const Marca = () => System.import('../../Produto/App/View/Marca.vue');

const Parceiro = () => System.import('../../Parceiro/App/View/Parceiro.vue');
const DadosParceiro = () => System.import('../../Parceiro/App/View/DadosParceiro.vue');
const Diretriz = () => System.import('../../Parceiro/App/View/Diretriz.vue');

export const CadastroRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: 'cadastro', component: Cadastro, name: 'cadastro', meta: { auth: true } },

      { path: 'cadastro/produto', component: Produto, name: 'cadastro-produto', meta: { auth: true } },
      { path: 'produto', component: Produto, name: 'produto', meta: { auth: true } },
      { path: 'produto/b2b', component: ProdutoB2B, alias:'produto', name: 'produtob2b', meta: { auth: true } },
      { path: 'produto/dados/:id', component: DadosProduto, name: 'dados-produto', meta: { auth: true, acao: 'consulta' } },
      { path: 'produto/incluir', component: DadosProduto, name: 'cadastrar-produto', meta: { auth: true, acao: 'incluir' } },
      { path: 'produto/alterar/:id', component: DadosProduto, name: 'alterar-produto', meta: { auth: true, acao: 'alterar'} },

      {path: 'cadastro/grupo', component: Grupo, name: 'produto-grupo', meta: { auth: true }},
      {path: 'cadastro/subgrupo', component: Subgrupo, name: 'produto-subgrupo', meta: { auth: true }},
      {path: 'cadastro/categoria', component: Categoria, name: 'produto-categoria', meta: { auth: true }},
      {path: 'cadastro/marca', component: Marca, name: 'produto-marca', meta: { auth: true }},

      {path: 'parceiro', component: Parceiro, name: 'parceiro-b2b', meta: {auth: true}},
      {path: 'cadastro/parceiro', component: Parceiro, name: 'parceiro', meta: {auth: true}},
      {path: 'parceiro/dados/:id', component: DadosParceiro, name: 'dados-parceiro', meta: {auth: true, acao: 'consulta'}},
      {path: 'parceiro/incluir', component: DadosParceiro, name: 'cadastrar-parceiro', meta: {auth: true, acao: 'incluir'}},
      {path: 'parceiro/alterar/:id', component: DadosParceiro, name: 'alterar-parceiro', meta: {auth: true, acao: 'alterar'}},
      {path: 'cadastro/diretriz', component: Diretriz, name:'parceiro-diretiz', props: true,  meta: {auth: true}}
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Cadastro/Rotas/Routes.js